import { EventEmitter, inject, Injectable, Output, ViewContainerRef } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DSM3ModalOptionsType, DSM3ModalService } from '@eredes/dsm3';
import { DSM34Dialog } from '@eredes/dsm34';
import moment from 'moment';

import { RequestModalComponent } from '../request-modal/request-modal.component';
import { RequestService } from '../request.service';

import { RequestDetail } from './request-detail.model';

@Injectable({
  providedIn: 'root',
})
export class RequestDetailService {
  request: RequestDetail;
  viewContainerRef: ViewContainerRef;
  isRet: boolean;

  dataRequestModal: any;

  @Output() closeModal = new EventEmitter();

  public dialog = inject(DSM34Dialog);

  constructor(
    private readonly modalService: DSM3ModalService,
    protected requestService: RequestService,
    protected router: Router,
    protected route: ActivatedRoute
  ) {}

  setServiceClassValues(request: RequestDetail, viewContainerRef: ViewContainerRef, isRet: boolean) {
    this.request = request;
    this.viewContainerRef = viewContainerRef;
    this.isRet = isRet;
  }

  /**
   * Main function that calls MS to save comments in request
   * Too change, check toChangeLaterFutureUsThis, function last param
   * @param form enum : FormGroup if textarea from form | string if textarea from Modal
   * @param internal which form was called 0 - To "Mensagens" with files | 1 - Internal notes just message
   * @param orign null for regular user | "popup" if "E-Redes" changes Type of request
   * @param origin
   * @param files
   */
  insertComment(form: any, internal: number, origin?: string, files?: UntypedFormArray) {
    const promiseFilesToUpload = [];
    if (files) {
      files.controls.forEach((control) => {
        promiseFilesToUpload.push(this.setReader(control.value));
      });
    }

    let comment = '';
    if (origin === 'popup') {
      comment = form;
    } else {
      comment = internal ? form.value.internalnotes : form.value.comment;
    }

    Promise.all(promiseFilesToUpload).then((filesToUpload) => {
      this.requestService.insertComment(this.request.detail.requestUniqueCode, comment, internal).subscribe(
        (data: any) => {
          if (origin !== 'popup') {
            if (internal === 1) {
              this.openModal(true, 'Nota interna inserida com sucesso!', '', true);
            } else {
              if (filesToUpload.length > 0) {
                const commentUniqueCode = data.Result.Collection.requestCommentUniqueId
                  ? data.Result.Collection.requestCommentUniqueId
                  : data.Result.lastInsertId;
                this.requestService
                  .insertCommentAttachments(filesToUpload, commentUniqueCode, this.request.detail.requestUniqueCode)
                  .subscribe(
                    (attachRes) => {
                      this.openModal(true, 'Resposta inserida com sucesso!', '', true);
                    },
                    (err) => {
                      this.openModal(false, 'Houve um erro na inserção dos anexos da resposta', 'Tente novamente.');
                      console.error(err);
                    }
                  );
              } else {
                this.openModal(true, 'Resposta inserida com sucesso!', '', true);
              }
            }
          }
        },
        (err: any) => {
          this.openModal(false, 'Houve um erro na inserção da resposta', 'Tente novamente.');
          console.error(err);
        }
      );
    });
  }

  /**
   * ReOpens current request, draws a confirm modal first
   * toEdit
   */
  reOpenRequest(): void {
    const modal = this.modalService.confirm(this.viewContainerRef, {
      title: this.isRet ? 'Reabrir Pedido ' + this.request.detail.requestMainId : 'Reabrir Pedido',
      message: this.isRet
        ? 'Deseja reabrir este pedido para a equipa da EDP?'
        : 'Tem a certeza que pretende reabrir o pedido?',
    });

    modal.onSubmit().subscribe((result) => {
      if (result === true) {
        this.requestService.updateReopenRequest(this.request.detail.requestUniqueCode).subscribe(
          (data: any) => {
            this.openModal(
              true,
              'Pedido reaberto com sucesso',
              'Pode novamente enviar mensagens e acompanhar o desenvolvimento do processo.'
            );
          },
          (err: any) => {
            this.openModal(false, 'Houve um erro na alteração do pedido.', 'Tente novamente.');
          }
        );
      }
    });
  }

  /**
   * Call to Close current Request, opens confirm modal first
   */
  cancelRequest(): void {
    const modal = this.modalService.confirm(this.viewContainerRef, {
      title: 'Atenção',
      message: 'Tem a certeza que pretende anular o Pedido ' + this.request.detail.requestMainId + '?',
    });
    modal.onSubmit().subscribe((result) => {
      if (result === true) {
        this.requestService.updateStatusReject(this.request.detail.requestUniqueCode).subscribe(
          (data: any) => {
            this.openModal(true, `Pedido ${this.request.detail.requestMainId} anulado com sucesso`, '');
          },
          (err: any) => {
            this.openModal(false, 'Houve um erro na alteração do pedido.', 'Tente novamente.');
          }
        );
      }
    });
  }

  /**
   * Calls MS to change request status
   * toEdit
   * @param status new status to change too
   * @param note   notes for the change
   * @param files  what attachments will be send with change status
   */
  submitChangeStatus(status, note, files?): void {
    this.requestService.changeStatus(this.request.detail.requestUniqueCode, status, note).subscribe(
      (data: any) => {
        if (
          data.Result &&
          data.Result.Collection[0] &&
          !data.Result.Collection[0].requestCommentPrivate &&
          files &&
          files.length > 0
        ) {
          const commentUniqueCode = data.Result.Collection[0].requestCommentUniqueId
            ? data.Result.Collection[0].requestCommentUniqueId
            : data.Result.lastInsertId;
          this.requestService
            .insertCommentAttachments(files, commentUniqueCode, this.request.detail.requestUniqueCode)
            .subscribe(
              (attachRes) => {
                this.openModal(true, 'A sua alteração ao pedido foi feita com sucesso!', '');
              },
              (err) => {
                this.openModal(false, 'Houve um erro na alteração do pedido.', 'Tente novamente.');
              }
            );
        } else {
          // When there's no file or it's request internal comment
          this.openModal(true, 'A sua alteração ao pedido foi feita com sucesso!', '');
        }
      },
      (err: any) => {
        this.openModal(false, 'Houve um erro na alteração do pedido.', 'Tente novamente.');
      }
    );
  }

  /**
   * Calls MS to change user attending request
   * toEdit
   * @param operationUniqueCode current request id
   * @param voltageUniqueCode
   */
  submitUpdateType(operationUniqueCode: string, voltageUniqueCode: string): void {
    this.requestService
      .updateRequestOperation(this.request.detail.requestUniqueCode, operationUniqueCode, voltageUniqueCode)
      .subscribe(
        (data: any) => {
          this.openModal(true, 'A sua alteração ao pedido foi feita com sucesso!', '');
        },
        (err: any) => {
          this.openModal(false, 'Houve um erro na alteração do pedido.', 'Tente novamente.');
        }
      );
  }

  /**
   * ReOpens requests Adding notes
   * @param detail
   */
  submitReOpen(detail: any): void {
    this.requestService.updateReopenRequest(this.request.detail.requestUniqueCode, detail.notes).subscribe(
      (data: any) => {
        this.openModal(
          true,
          'Pedido reaberto com sucesso',
          'Pode novamente enviar mensagens e acompanhar o desenvolvimento do processo.'
        );
      },
      (err: any) => {
        this.openModal(false, 'Houve um erro na alteração do pedido.', 'Tente novamente.');
      }
    );
  }

  /**
   * Submit User Realocation
   */
  submitRealocate(): void {
    this.requestService.realocate(this.request.detail.requestUniqueCode).subscribe(
      (data: any) => {
        this.openModal(true, 'A sua alteração ao pedido foi feita com sucesso!', '');
      },
      (err: any) => {
        this.openModal(false, 'Houve um erro na alteração do pedido.', 'Tente novamente.');
      }
    );
  }

  /**
   * Open Modal to change Request Type
   * @param detail
   */
  changeType(detail: any): void {
    this.dataRequestModal = {
      modalTitle: 'Alterar Tipo do Pedido ' + detail.requestMainId + '',
      btnConfirmText: 'Submeter',
      btnCancelText: 'Cancelar',
      infoDetail: detail,
      changeType: true,
    };
    this.openRequestDialog(RequestModalComponent);
  }

  /**
   * Open Modal to Realocate Request's User
   * @param detail
   */
  changeRealocate(detail: any): void {
    this.dataRequestModal = {
      modalTitle: 'Realocar Pedido ' + detail.requestMainId + '',
      modalText: 'Deseja alocar este pedido à equipa da EDP?',
      btnConfirmText: 'Sim',
      btnCancelText: 'Não',
      infoDetail: detail,
      changeUser: true,
    };
    this.openRequestDialog(RequestModalComponent);
  }

  /**
   * Open Modal to Change request Status
   * @param detail
   */
  changeStatus(detail: any): void {
    this.dataRequestModal = {
      modalTitle: 'Alterar Estado do Pedido ' + detail.requestMainId + '',
      btnConfirmText: 'Submeter',
      btnCancelText: 'Cancelar',
      infoDetail: detail,
      changeStatus: true,
      allStatus: this.request.possibleStatus,
    };
    this.openRequestDialog(RequestModalComponent);
  }

  /**
   * Manages after data modals, which MS is to call
   * @param component RequestModalComponent data modal
   */
  openRequestDialog(component) {
    const requestDialog = this.dialog.open(component, {
      data: this.dataRequestModal,
      disableClose: false,
    });
    requestDialog.afterClosed().subscribe((result) => {
      if (result.event === true) {
        // CLOSE MODAL CLICK "btnConfirmText"
        if (this.dataRequestModal.changeType) {
          const lastType = result.data.type2;
          const voltage = result.data.voltage;
          const notes = result.data.notes;
          if (notes !== '') {
            this.insertComment(notes, 1, 'popup');
          }
          this.submitUpdateType(lastType, voltage);
        } else if (this.dataRequestModal.changeStatus) {
          this.submitChangeStatus(result.data.status, result.data.notes, result.data.files);
        } else if (this.dataRequestModal.reOpen) {
          this.submitReOpen(result.data);
        } else {
          this.submitRealocate();
        }
      } else if (result.event === false) {
        // CLOSE MODAL CLICK "btnCancelText"
      } else {
        // CLOSE MODAL CLICK "mat-dialog-close"
      }
    });
  }

  /**
   * Generic function that writes final result of MS
   * @param success true case success, false case error
   * @param title string to bold message
   * @param message string to description
   * @param reload true case reload page, false goes to list
   */
  openModal(success: boolean, title: string, message: string, reload = false): void {
    const modal = this.modalService.open(this.viewContainerRef, {
      title: title,
      message: message,
      type: success ? DSM3ModalOptionsType.SUCCESS : DSM3ModalOptionsType.ERROR,
    });

    if (success) {
      modal.onClose().subscribe(() => {
        this.closeModal.emit(reload);
      });
    }
  }

  /**
   * Whether log user create Internal Comment
   * @param value MS Message Field
   * @returns boolean, true is user can see Internal Comment Form
   */
  checkIsRetailer(value: any): boolean {
    const res = this.request.comments.find((obj) => {
      return obj.createdUserIsInternal === value;
    });
    if (res && res.createdUserIsInternal === '1') {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Returns the date with the new format
   * @param date date to be formated
   * @returns date with new format (dd/mm/yyyy às hh/mm)
   */
  formatDateWithString(date: string): string {
    return moment(date).local().format('DD/MM/YYYY') + ' às ' + moment(date).local().format('HH:mm');
  }

  /**
   * Returns filesize in units ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
   * @param fileSize filesize in bytes
   * @returns filesize with units
   */
  fileSize(fileSize): string {
    const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    let l = 0,
      n = parseInt(fileSize, 10) || 0;

    while (n >= 1024 && ++l) {
      n = n / 1024;
    }

    return n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l];
  }

  /**
   * Prepares file content to send
   * @param file reference to file in the multi-file-Upload
   * @returns Promise to finish reader of file
   */
  private setReader(file: File): Promise<any> {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = function (e) {
        resolve({
          fileName: file.name,
          fileSize: file.size,
          fileType: file.type,
          fileContent: 'data:' + file.type + ';base64,' + reader.result.toString().split(',')[1],
        });
      };
      reader.readAsDataURL(file);
    });
  }
}
